import { EditorMode, FilterValues, filterToUri } from '@sdxcorp/sdx-dds-gui-lib';

const adminRootPath = '/admin';

export const Paths = Object.freeze({
  default: '/',
  dashboard: adminRootPath + '/',
  library: adminRootPath + '/library/:component?',
  settlementInstructions: {
    overview: adminRootPath + '/transactions/settlement-instructions/:tab?',
    details: adminRootPath + '/transactions/settlement-instructions/:tab/:subType?/:mode(view|edit|create|changes|from)/:id?',
  },
  paymentInstructions: {
    overview: adminRootPath + '/transactions/payment-instructions/:tab?',
    details: adminRootPath + '/transactions/payment-instructions/:tab/:subType?/:mode(view|edit|create|changes|from)/:id?',
  },
  whitelistedAddresses: {
    overview: adminRootPath + '/whitelistedAddresses/:tab?',
    details: adminRootPath + '/whitelistedAddresses/:tab/:subType?/:mode(view|edit|create|changes|from)/:id?',
  },
  externalEntities: {
    overview: adminRootPath + '/externalEntities/:tab?',
    details: adminRootPath + '/externalEntities/:tab/:subType?/:mode(view|edit|create|changes|from)/:id?',
  },
  assets: {
    overview: adminRootPath + '/assets',
    details: adminRootPath + '/assets/:subType?/:mode(view|edit|create|changes|from)/:id?',
  },
  members: {
    overview: adminRootPath + '/members',
    details: adminRootPath + '/members/:mode(view|edit|create|changes|from)/:id?',
  },
  memberSubscriptions: {
    overview: adminRootPath + '/memberSubscriptions',
    details: adminRootPath + '/memberSubscriptions/:mode(view|edit|create|changes|from)/:id?',
  },
  transferRestriction: {
    overview: adminRootPath + '/transferRestriction',
    details: adminRootPath + '/transferRestriction/:mode(view|edit|create|changes|from)/:id?',
  },
  eligibilityOnRestrictedAsset: {
    overview: adminRootPath + '/eligibilityOnRestrictedAsset',
    details: adminRootPath + '/eligibilityOnRestrictedAsset/:mode(view|edit|create|changes|from)/:id?',
  },
  listingRequest: {
    overview: adminRootPath + '/listingRequest/:tab?/:selectedMember?',
    details: adminRootPath + '/listingRequest/:tab?/:selectedMember?/:mode(view|edit|create|changes|from)/:id?',
  },
  accounts: {
    overview: adminRootPath + '/accounts',
    details: adminRootPath + '/accounts/:mode(view|edit|create|changes|from)/:id?',
  },
  externalAccounts: {
    overview: adminRootPath + '/externalAccounts',
    details: adminRootPath + '/externalAccounts/:mode(view|edit|create|changes|from)/:id?',
  },
  legalEntities: {
    overview: adminRootPath + '/LegalEntity/overview',
    details: adminRootPath + '/LegalEntity/:mode(view|edit|create|changes|from)/:id?',
  },
  currencies: {
    overview: adminRootPath + '/currencies',
    details: adminRootPath + '/currencies/:mode(view|edit|create|changes|from)/:id?',
    changes: adminRootPath + '/currencies/changes/:id?',
  },
  cryptoDepositWithdrawals: {
    overview: adminRootPath + '/transactions/deposit-withdrawal/:tab?',
    details: adminRootPath + '/transactions/deposit-withdrawal/:tab/:subType?/:mode(view|edit|create|changes|from)/:id?',
  },
  cashTransactions: {
    overview: adminRootPath + '/technical-issuer/cash-transactions/:tab?',
    details: adminRootPath + '/technical-issuer/cash-transactions/:tab/:subType?/:mode(view|edit|create|changes)/:id?',
  },
  outstandingTokens: adminRootPath + '/technical-issuer/outstanding-tokens',
  memberBalanceReport: adminRootPath + '/technical-issuer/member-balance-report',
  memberAccountBalanceReport: adminRootPath + '/technical-issuer/member-account-balance-report',
  movementReport: adminRootPath + '/technical-issuer/movement-report',
  settlementInstructionReport: adminRootPath + '/technical-issuer/settlement-instruction-report',
  paymentInstructionReport: adminRootPath + '/technical-issuer/payment-instruction-report',
  currencyEligibilityList: {
    overview: adminRootPath + '/technical-issuer/currency-eligibility-list',
    details: adminRootPath + '/technical-issuer/currency-eligibility-list/:mode(view|edit|create|changes)/:id?',
  },
  assetTransactions: {
    overview: adminRootPath + '/technical-issuer/asset-transactions/:tab?',
    details: adminRootPath + '/technical-issuer/asset-transactions/:tab/:subType?/:mode(view|edit|create|changes)/:id?',
  },
  holdingsCurrent: adminRootPath + '/holdings/current/:tab?/:account?',
  holdingsHistorical: adminRootPath + '/holdings/historical/:tab?/:account?',
  movements: adminRootPath + '/movements/:tab?',
  scheduler: adminRootPath + '/operations/scheduler',
  businessAuditLog: {
    overview: adminRootPath + '/operations/audit-log',
    details: adminRootPath + '/operations/audit-log/:subType?/:mode(view)/:id?',
  },
  businessCalendar: {
    overview: adminRootPath + '/operations/business-calendar',
    details: adminRootPath + '/operations/business-calendar/:subType?/:mode(view|edit|create|changes)/:id?',
  },
  businessCalendarDay: {
    overview: adminRootPath + '/operations/business-calendar-day',
    details: adminRootPath + '/operations/business-calendar-day/:subType?/:mode(view|edit|create|changes)/:id?',
  },
  corporateActions: {
    overview: adminRootPath + '/corporate-actions/:tab?',
    details: adminRootPath + '/corporate-actions/:tab/:subType?/:mode(view|edit|create|changes)/:id?',
  },
  corporateActionProfiles: {
    overview: adminRootPath + '/corporate-action-profiles',
    details: adminRootPath + '/corporate-action-profiles/:mode(view|edit|create|changes|from)/:id?',
  },
  subbalanceTransfers: {
    overview: adminRootPath + '/operations/subbalance-transfers/:tab?',
    details: adminRootPath + '/operations/subbalance-transfers/:tab/:mode(view|edit|create|changes)/:id?',
  },
  assetSubbalanceTransfers: {
    overview: adminRootPath + '/operations/asset-subbalance-transfers/:tab?',
    details: adminRootPath + '/operations/asset-subbalance-transfers/:tab/:mode(view|edit|create|changes)/:id?',
  },
  onboarding: {
    overview: adminRootPath + '/operations/onboarding',
  },
  tradingParticipants: {
    overview: adminRootPath + '/operations/trading-participants',
    details: adminRootPath + '/operations/trading-participants/:mode(view|edit|create|changes|from)/:id?',
  },
  standingSettlementInstructions: {
    overview: adminRootPath + '/standing-settlement-instructions',
    details: adminRootPath + '/standing-settlement-instructions/:mode(view|edit|create|changes|from)/:id?',
  },
  fractionalisationAssets: {
    overview: adminRootPath + '/fractionalisationAssets',
    details: adminRootPath + '/fractionalisationAssets/:mode(view|edit|create|changes|from)/:id?',
  },
  taxIncomeCodes: {
    overview: adminRootPath + '/operations/taxIncomeCodes',
    details: adminRootPath + '/operations/taxIncomeCodes/:mode(view|edit|create|changes|from)/:id?',
  },
  taxExemptionCodes: {
    overview: adminRootPath + '/operations/taxExemptionCodes',
    details: adminRootPath + '/operations/taxExemptionCodes/:mode(view|edit|create|changes|from)/:id?',
  },
});

export const adminRouteTo = {
  dashboard: () => Paths.dashboard,
  library: () => Paths.library,
  settlementInstructions: ({ filter, tab = 'allegements' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.settlementInstructions.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  settlementInstructionDetails: ({ mode, subType, id, tab = 'allegements' }: { mode: EditorMode; subType?: string; id?: string; tab?: string }) =>
    Paths.settlementInstructions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  settlementInstructionFrom: ({ subType, id, tab = 'allegements' }: { subType: string; id: string; tab?: string }) =>
    Paths.settlementInstructions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', '/' + subType)
      .replace(':mode(view|edit|create|changes|from)', EditorMode.FROM.toLowerCase())
      .replace('/:id?', '/' + id),
  paymentInstructions: ({ filter, tab = 'open_instructions' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.paymentInstructions.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  paymentInstructionDetails: ({
    mode,
    subType,
    id,
    tab = 'open_instructions',
  }: {
    mode: EditorMode;
    subType?: string;
    id?: string;
    tab?: string;
  }) => {
    return Paths.paymentInstructions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : '');
  },
  whitelistedAddresses: ({ filter, tab = 'deposit_addresses' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.whitelistedAddresses.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  whitelistedAddressDetails: ({ mode, subType, id, tab = 'deposit_addresses' }: { mode: EditorMode; subType?: string; id?: string; tab?: string }) =>
    Paths.whitelistedAddresses.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  externalEntities: ({ filter, tab = 'CUSTODIAL' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.externalEntities.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  externalEntityDetails: ({ mode, subType, id, tab = 'CUSTODIAL' }: { mode: EditorMode; subType?: string; id?: string; tab?: string }) =>
    Paths.externalEntities.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  assetsOverview: () => Paths.assets.overview,
  assetDetails: ({ mode, subType, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.assets.details
      .replace('/:subType?', '/' + subType)
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  membersOverview: () => Paths.members.overview,
  memberDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.members.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  memberSubscriptionOverview: () => Paths.memberSubscriptions.overview,
  memberSubscriptionDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.memberSubscriptions.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  transferRestrictionOverview: () => Paths.transferRestriction.overview,
  transferRestrictionDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.transferRestriction.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  eligibilityOnRestrictedAssetOverview: () => Paths.eligibilityOnRestrictedAsset.overview,
  eligibilityOnRestrictedAssetDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.eligibilityOnRestrictedAsset.details
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  listingRequestOverview: ({ tab = 'accepted', selectedMember }: { tab?: string; selectedMember?: string }) =>
    Paths.listingRequest.overview.replace('/:tab?', `/${tab}`).replace('/:selectedMember?', selectedMember ? `/${selectedMember}` : ''),
  listingRequestDetails: ({
    mode,
    tab = 'accepted',
    selectedMember,
    id,
    isin,
  }: {
    mode: EditorMode;
    tab?: string;
    selectedMember?: string;
    id?: string;
    isin?: string;
  }) =>
    Paths.listingRequest.details
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:tab?', `/${tab}`)
      .replace('/:selectedMember?', selectedMember ? `/${selectedMember}` : '')
      .replace('/:id?', isin ? '/' + isin : ''),
  legalEntitiesOverview: () => Paths.legalEntities.overview,
  legalEntityDetails: ({ mode, id }: { mode: EditorMode; id?: string }) =>
    Paths.legalEntities.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  accountsOverview: () => Paths.accounts.overview,
  externalAccountsOverview: () => Paths.externalAccounts.overview,
  externalAccountDetails: ({ mode, id }: { mode: EditorMode; id?: string }) =>
    Paths.externalAccounts.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  currenciesOverview: () => Paths.currencies.overview,
  accountDetails: ({ mode, id }: { mode: EditorMode; id?: string }) =>
    Paths.accounts.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  currencyEligibilityListOverview: () => Paths.currencyEligibilityList.overview,
  currencyEligibilityListDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.currencyEligibilityList.details.replace(':mode(view|edit|create|changes)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  currencyDetails: ({ mode, id }: { mode: EditorMode; id?: string }) =>
    Paths.currencies.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  cryptoDepositWithdrawals: ({ filter, tab = 'open_instructions' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.cryptoDepositWithdrawals.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  cryptoDepositWithdrawalDetails: ({
    mode,
    subType,
    id,
    tab = 'open_instructions',
  }: {
    mode: EditorMode;
    subType?: string;
    id?: string;
    tab?: string;
  }) =>
    Paths.cryptoDepositWithdrawals.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  cashTransactions: ({ filter, tab = 'open_instructions' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.cashTransactions.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  cashTransactionDetails: (mode: EditorMode, subType?: string, id?: string, tab = 'open_instructions') =>
    Paths.cashTransactions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  assetTransactions: ({ filter, tab = 'allegements' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.assetTransactions.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  assetTransactionDetails: ({ mode, subType, id, tab = 'allegements' }: { mode: EditorMode; subType?: string; id?: string; tab?: string }) =>
    Paths.assetTransactions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  assetTransactionsFrom: ({ subType, id, tab = 'allegements' }: { subType: string; id: string; tab?: string }) =>
    Paths.assetTransactions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', '/' + subType)
      .replace(':mode(view|edit|create|changes|from)', EditorMode.FROM.toLowerCase())
      .replace('/:id?', '/' + id),
  holdingsCurrent: (tab = 'assets', account?: string) =>
    Paths.holdingsCurrent.replace('/:tab?', `/${tab}`).replace('/:account?', account ? `/${account}` : ''),
  holdingsHistorical: (tab = 'assets', account?: string) =>
    Paths.holdingsHistorical.replace('/:tab?', `/${tab}`).replace('/:account?', account ? `/${account}` : ''),
  movements: ({ filter, tab = 'asset' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.movements.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  movementsAssets: ({ filter, tab = 'asset' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.movements.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  movementsCash: ({ filter, tab = 'cash' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.movements.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  corporateActionsOverview: ({ filter, tab = 'own-asset-events' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.corporateActions.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  corporateActionDetails: ({ mode, subType, id, tab = 'own-asset-events' }: { mode: EditorMode; subType?: string; id?: string; tab?: string }) =>
    Paths.corporateActions.details
      .replace('/:tab', `/${tab}`)
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  corporateActionProfilesOverview: () => Paths.corporateActionProfiles.overview,
  corporateActionProfileDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.corporateActionProfiles.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  businessAuditLogOverview: () => Paths.businessAuditLog.overview,
  businessAuditLogDetails: (mode: EditorMode, subType?: string, id?: string) =>
    Paths.businessAuditLog.details
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  businessCalendarOverview: () => Paths.businessCalendar.overview,
  businessCalendarDetails: (mode: EditorMode, subType?: string, id?: string) =>
    Paths.businessCalendar.details
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  businessCalendarDayOverview: () => Paths.businessCalendarDay.overview,
  businessCalendarDayDetails: (mode: EditorMode, subType?: string, id?: string) =>
    Paths.businessCalendarDay.details
      .replace('/:subType?', subType ? '/' + subType : '')
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  subbalanceTransfers: ({ filter, tab = 'open_instructions' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.subbalanceTransfers.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  subbalanceTransferDetails: (mode: EditorMode, id?: string, tab = 'open_instructions') =>
    Paths.subbalanceTransfers.details
      .replace('/:tab', `/${tab}`)
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  assetSubbalanceTransfers: ({ filter, tab = 'open_instructions' }: { filter?: FilterValues | string; tab?: string }) =>
    Paths.assetSubbalanceTransfers.overview.replace('/:tab?', `/${tab}`) + filterToUri(filter),
  assetSubbalanceTransferDetails: (mode: EditorMode, id?: string, tab = 'open_instructions') =>
    Paths.assetSubbalanceTransfers.details
      .replace('/:tab', `/${tab}`)
      .replace(':mode(view|edit|create|changes)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  onboardingOverview: () => Paths.onboarding.overview,
  tradingParticipantOverview: () => Paths.tradingParticipants.overview,
  tradingParticipantDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.tradingParticipants.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  standingSettlementInstructionsOverview: () => Paths.standingSettlementInstructions.overview,
  standingSettlementInstructionDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.standingSettlementInstructions.details
      .replace(':mode(view|edit|create|changes|from)', mode.toLowerCase())
      .replace('/:id?', id ? '/' + id : ''),
  fractionalisationAssetsOverview: () => Paths.fractionalisationAssets.overview,
  fractionalisationAssetDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.fractionalisationAssets.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  taxIncomeCodesOverview: () => Paths.taxIncomeCodes.overview,
  taxIncomeCodesDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.taxIncomeCodes.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
  taxExemptionCodesOverview: () => Paths.taxExemptionCodes.overview,
  taxExemptionCodesDetails: ({ mode, id }: { mode: EditorMode; subType?: string; id?: string }) =>
    Paths.taxExemptionCodes.details.replace(':mode(view|edit|create|changes|from)', mode.toLowerCase()).replace('/:id?', id ? '/' + id : ''),
};
